import React, { PropTypes } from 'react';
import { icon } from './../../../../icons/icons';

const Input = (props) => {
    const { widget, actions } = props;

    const onChange = (id, e) => {
        actions.setInputWidgetPlaceholder(id, e.target.value);
    };

    const goBack = () => {
        actions.setWidgetTools('general');
    };

    return (
        <div className="option">
            <h3 className="option__header">{widget.type} Edit</h3>
            <textarea value={widget.placeholder} onChange={onChange.bind(this, widget.id)} />
            <div className="option__back" onClick={goBack} title="Back">{icon.backArrow()}</div>
        </div>
    );
};

Input.propTypes = {
    actions: PropTypes.object.isRequired,
    widget: PropTypes.shape({
        id: PropTypes.number.isRequired,
        type: PropTypes.string.isRequired,
        kind: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }).isRequired,
};

export default Input;



// WEBPACK FOOTER //
// ./src/_app/quick_response/components/Tools/Widgets/Input/Input.jsx